const isNegativeEleReportError = (error) => error?.error === "negative_ele";

module.exports = { isNegativeEleReportError };
